// element-ui 语言包
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
export default {
  ...zhLocale,
  数字资产化平台: "数字资产化平台",
  请设置社区名称: "请设置社区名称",
  "将现实世界资产(Real World Assets)通过区块链技术数字化，提供透明、高效的资产交易与管理服务":
    "将现实世界资产(Real World Assets)通过区块链技术数字化，提供透明、高效的资产交易与管理服务",
  目标IRR: "目标IRR",
  浏览项目: "浏览项目",
  主推产品: "主推产品",
  运作方式: "运作方式",
  "将现实世界资产(Real World Assets)通过区块链技术数字化，提供透明、高效的资产交易与管理服务":
    "将现实世界资产(Real World Assets)通过区块链技术数字化，提供透明、高效的资产交易与管理服务",
  目标收益率: "目标收益率",
  了解完整流程: "了解完整流程",
  资产透明: "资产透明",
  "所有资产信息上链可查,确保真实可靠": "所有资产信息上链可查,确保真实可靠",
  收益稳定: "收益稳定",
  "精选优质资产,提供稳定可观收益": "精选优质资产,提供稳定可观收益",
  交易便捷: "交易便捷",
  "7x24小时交易,随时买卖变现": "7x24小时交易,随时买卖变现",
  安全合规: "安全合规",
  "多重安全保障,合规运营": "多重安全保障,合规运营",
  "创建账户并完成客户身份验证(KYC)": "创建账户并完成客户身份验证(KYC)",
  所有投资者均需满足此要求: "所有投资者均需满足此要求",
  浏览标记化项目: "浏览标记化项目",
  "多户型住宅、商业地产、综合体、零售地产和酒店资产":
    "多户型住宅、商业地产、综合体、零售地产和酒店资产",
  连接你的钱包: "连接你的钱包",
  "通过MetaMask进行自我托管,或使用Ternova的平台钱包":
    "通过MetaMask进行自我托管,或使用Ternova的平台钱包",
  数字化投资与持有: "数字化投资与持有",
  "代币代表特殊目的载体(SPV)或基金中的股权":
    "代币代表特殊目的载体(SPV)或基金中的股权",
  条件: "条件",
  已完成: "已完成",
  去完成: "去完成",
  确认申请: "确认申请",
  申请社区: "申请社区",
  申请合伙人: "申请合伙人",
  邀请: "邀请",
  个会员: "个会员",
  认购资产价值达: "认购资产价值达",
  社区人数达到: "社区人数达到",
  人: "人",
  个人认购资产达: "个人认购资产达",
  社区会员认购资产价值达: "社区会员认购资产价值达",
  请先完成申请条件: "请先完成申请条件",
  请设置社区名称: "请设置社区名称",
  不能超过50字符: "不能超过50字符",
  获赞: "获赞",
  留言: "留言",
  邀请好友: "邀请好友",
  我发布的: "我发布的",
  暂无: "暂无",
  人留言: "人留言",
  人点赞: "人点赞",
  暂无数据: "暂无数据",
  "加载中...": "加载中...",
  加载更多: "加载更多",
  社区名称: "社区名称",
  保存名字: "保存名字",
  请输入社区名称: "请输入社区名称",
  最长20字符: "最长20字符",
  合伙人社区: "合伙人社区",
  热门社区: "热门社区",
  暂无: "暂无",
  申请社区: "申请社区",

  申请合伙人: "申请合伙人",
  我的社区: "我的社区",
  已经成为合伙人: "已经成为合伙人",
  话题详情: "话题详情",
  回复: "回复",

  作者: "作者",
  收起回复: "收起回复",
  已经成为合伙人: "已经成为合伙人",
  话题详情: "话题详情",
  帮助文档: "帮助文档",
  发布: "发布",
  "回复@": "回复@",
  "说点什么…": "说点什么…",
  请输入内容: "请输入内容",
  "内容长度需控制在 5000 字符以内": "内容长度需控制在 5000 字符以内",

  帮助文档详情: "帮助文档详情",
  关于我们: "关于我们",
  TER币和RWA项目代币介绍: "TER币和RWA项目代币介绍",
  数字资产平台: "数字资产平台",
  查看和收购资产: "查看和收购资产",
  进入交易所: "进入交易所",
  数字资产银行: "数字资产银行",
  快速兑换主流数字资产: "快速兑换主流数字资产",
  立即兑换: "立即兑换",
  核心优势: "核心优势",
  合伙人社区: "合伙人社区",
  收起回复: "收起回复",
  "利益共享，打造合伙人共赢生态圈": "利益共享，打造合伙人共赢生态圈",
  进入社区: "进入社区",
  关于我们: "关于我们",
  联系我们: "联系我们",
  访问官网: "访问官网",
  资产透明: "资产透明",
  收益稳定: "收益稳定",
  交易便捷: "交易便捷",
  安全合规: "安全合规",
  月: "月",
  日: "日",
  没有跳转链接: "没有跳转链接",
  请登录后进入: "请登录后进入",
  可认购: "可认购",
  邀请好友加入: "邀请好友加入",
  我的邀请: "我的邀请",
  复制链接邀请好友: "复制链接邀请好友",
  复制成功: "复制成功",
  复制失败: "复制失败",
  邀请记录: "邀请记录",
  "将现实世界资产(Real World Assets)通过区块链技术数字化，提供透明、高效的资产交易与管理服务。":
    "将现实世界资产(Real World Assets)通过区块链技术数字化，提供透明、高效的资产交易与管理服务。",
  进入RWA的世界: "进入RWA的世界",
  资产列表: "资产列表",
  奖励余额: "奖励余额",
  我的认购: "我的认购",
  请选择类型: "请选择类型",
  搜索资产: "搜索资产",
  我的认购: "我的认购",
  可认购: "可认购",
  已结束: "已结束",
  可预约: "可预约",
  售价: "售价",
  持有: "持有",
  总值: "总值",
  剩余: "剩余",

  资产列表: "资产列表",
  奖励余额: "奖励余额",
  我的认购: "我的认购",
  请选择类型: "请选择类型",
  搜索资产: "搜索资产",
  我的认购: "我的认购",
  可认购: "可认购",
  已结束: "已结束",
  可预约: "可预约",
  售价: "售价",
  持有: "持有",
  总值: "总值",
  剩余: "剩余",

  资产列表: "资产列表",
  奖励余额: "奖励余额",
  我的认购: "我的认购",
  请选择类型: "请选择类型",
  搜索资产: "搜索资产",
  我的认购: "我的认购",
  可认购: "可认购",
  已结束: "已结束",
  可预约: "可预约",
  售价: "售价",
  持有: "持有",
  总值: "总值",
  剩余: "剩余",

  我的认购: "我的认购",
  认购代币: "认购代币",
  认购数量: "认购数量",
  提取代币: "提取代币",
  确认提取: "确认提取",
  暂无可提取: "暂无可提取",
  请输入提取数量: "请输入提取数量",
  余额不足: "余额不足",
  "交易进行中,请勿进行其他操作": "交易进行中,请勿进行其他操作",
  "进行提取代币操作时，提取失败": "进行提取代币操作时，提取失败",
  奖励余额: "奖励余额",
  提取余额: "提取余额",
  提取记录: "提取记录",

  奖励余额: "奖励余额",
  提取余额: "提取余额",
  认购进度: "认购进度",
  底层资产介绍: "底层资产介绍",
  资产数字化详情: "资产数字化详情",
  发行总量: "发行总量",
  枚: "枚",
  已售数量: "已售数量",
  预约数: "预约数",
  锁定期: "锁定期",
  个月: "个月",
  分红机制: "分红机制",
  实时数据: "实时数据",
  剩余可认购数量: "剩余可认购数量",
  当前已预约数: "当前已预约数",

  收益率: "收益率",
  平均分红金额: "平均分红金额",
  项目认购: "项目认购",
  新项目预约: "新项目预约",
  用户拒绝支付: "用户拒绝支付",
  剩余可认购数量为: "剩余可认购数量为",
  剩余可认购数量: "剩余可认购数量",
  请先进行KYC认证: "请先进行KYC认证",
  KYC认证审核中: "KYC认证审核中",
  "上传图片/视频": "上传图片/视频",
  发布: "发布",
  "1、视频文件过大时压缩时间较长，请耐心等待":
    "1、视频文件过大时压缩时间较长，请耐心等待",
  "2、若出现黑屏，请清理手机内存": "2、若出现黑屏，请清理手机内存",
  "3、建议您调整手机拍摄清晰度选择720p及以下的规格进行拍摄":
    "3、建议您调整手机拍摄清晰度选择720p及以下的规格进行拍摄",
  "仅支持图片或视频文件！": "仅支持图片或视频文件！",
  视频大小不能超过100MB: "视频大小不能超过100MB",
  图片大小不能超过5MB: "图片大小不能超过5MB",
  上传失败: "上传失败",
  切换语言成功: "切换语言成功",

  天前: "天前",
  小时前: "小时前",
  分钟前: "分钟前",
  刚刚: "刚刚",
  亿: "亿",
  万: "万",
  没有更多了: "没有更多了",
  展开回复: "展开回复",

  投资年限: "投资年限",
  起投金额: "起投金额",
  认购价格: "认购价格",
  个: "个",
  预约认购: "预约认购",
  认购资产: "认购资产",
  确认认购: "确认认购",
  限购: "限购",
  总价: "总价",
  预约认购数量: "预约认购数量",
  确认预约: "确认预约",
  "预约 CTA": "立即预约",
  年: "年",
  立即认购: "立即认购",
  KYC认证: "KYC认证",
  连接钱包: "连接钱包",
  姓名: "姓名",
  国籍: "国籍",
  电话: "电话",
  邮箱: "邮箱",
  所在区域: "所在区域",
  其他: "其他",
  请输入姓名: "请输入姓名",
  请输入国籍: "请输入国籍",
  请输入电话: "请输入电话",
  请输入邮箱: "请输入邮箱",
  请输入所在区域: "请输入所在区域",
  "KYC认证(审核中)": "KYC认证(审核中)",
  "KYC认证(审核通过)": "KYC认证(审核通过)",
  选择语言: "选择语言",
  确定: "确定",
  请输入: "请输入",
  邀请好友加入: "邀请好友加入",
  运作方式: "运作方式",
  在Ternova投资代币化房地产: "在Ternova投资代币化房地产",
  "Ternova使得利用现代数字基础设施投资现实世界资产成为可能。 该流程旨在简洁、灵活且易于理解——尤其适合初次接触数字资产的投资者":
    "Ternova使得利用现代数字基础设施投资现实世界资产成为可能。 该流程旨在简洁、灵活且易于理解——尤其适合初次接触数字资产的投资者",
  创建帐户: "创建帐户",
  流动性随时间变化: "流动性随时间变化",
  代币化旨在使所有权比传统的房地产结构更灵活:
    "代币化旨在使所有权比传统的房地产结构更灵活",
  "虽然投资应着眼于长远,但Ternova正在逐步增加额外的流动性选择":
    "虽然投资应着眼于长远,但Ternova正在逐步增加额外的流动性选择",
  资源: "资源",
  常见问题: "常见问题",
  重要注意事项: "重要注意事项",
  "所有投资都有风险。房地产投资可能会受到市场状况、运营因素和更广泛的经济趋势的影响":
    "所有投资都有风险。房地产投资可能会受到市场状况、运营因素和更广泛的经济趋势的影响",
  "代币化资产并非没有风险，其流动性可能不如公开交易的证券":
    "代币化资产并非没有风险，其流动性可能不如公开交易的证券",
  "投资前请仔细审查所有项目材料和披露。每次发行都有完整的法律披露":
    "投资前请仔细审查所有项目材料和披露。每次发行都有完整的法律披露",
  "本页面内容旨在帮助您做出更充分的信息判断，并不替代您自身的评估或专业建议。":
    "本页面内容旨在帮助您做出更充分的信息判断，并不替代您自身的评估或专业建议。",
  "如需继续了解，您可以返回平台浏览可用项目，或查看投资流程说明":
    "如需继续了解，您可以返回平台浏览可用项目，或查看投资流程说明",
  浏览项目: "浏览项目",
  运作方式: "运作方式",
  "谁可以在 Ternova 上投资": "谁可以在 Ternova 上投资",
  什么时候需要进行身份认证: "什么时候需要进行身份认证",
  投资回报如何发放: "投资回报如何发放",
  "什么是真实世界资产(RWA)": "什么是真实世界资产(RWA)",
  "真实世界资产(RWA)是指在现实世界中存在的资产，例如房屋、车辆、股票等":
    "真实世界资产(RWA)是指在现实世界中存在的资产，例如房屋、车辆、股票等",
  "在投资领域中，这通常包括房地产、基础设施以及持续经营、能够产生收入的企业资产":
    "在投资领域中，这通常包括房地产、基础设施以及持续经营、能够产生收入的企业资产",
  "与纯数字资产不同，真实世界资产依托于实体物业、合同现金流和真实经济活动，其价值基础不完全依赖市场情绪":
    "与纯数字资产不同，真实世界资产依托于实体物业、合同现金流和真实经济活动，其价值基础不完全依赖市场情绪",
  符号化不动产解释: "符号化不动产解释",
  代币化房地产说明: "代币化房地产说明",
  代币化房地产是指将房地产投资中的所有权以数字形式进行表示:
    "代币化房地产是指将房地产投资中的所有权以数字形式进行表示",
  "在Ternova上，代币代表真实世界资产中的股权权益，通常通过结构化投资载体持有。这些代币在功能上类似于数字化的股票凭证，代表所有权，而非投机行为":
    "在Ternova上，代币代表真实世界资产中的股权权益，通常通过结构化投资载体持有。这些代币在功能上类似于数字化的股票凭证，代表所有权，而非投机行为",
  "代币化提升了所有权的管理与发行效率，但并不改变投资的基本逻辑。物业运营表现、收入能力和长期价值仍然是核心":
    "代币化提升了所有权的管理与发行效率，但并不改变投资的基本逻辑。物业运营表现、收入能力和长期价值仍然是核心",
  与传统结构相比的符号化: "与传统结构相比的符号化",
  代币化与传统结构的对比: "代币化与传统结构的对比",
  "传统房地产投资通常存在投资门槛较高、流程复杂、透明度有限等特点":
    "传统房地产投资通常存在投资门槛较高、流程复杂、透明度有限等特点",
  "代币化在多个方面带来改进空间：更易参与、更清晰的所有权表达、更简化的管理流程、数字化记录方式":
    "代币化在多个方面带来改进空间：更易参与、更清晰的所有权表达、更简化的管理流程、数字化记录方式",
  "同时，代币化投资本质上仍是房地产投资，依然存在风险，需要审慎评估，并适合以长期视角参与":
    "同时，代币化投资本质上仍是房地产投资，依然存在风险，需要审慎评估，并适合以长期视角参与",
  钱包和数字所有权基础: "钱包和数字所有权基础",
  钱包与数字所有权基础说明: "钱包与数字所有权基础说明",
  数字钱包是一种用于存储和管理数字化所有权记录的工具:
    "数字钱包是一种用于存储和管理数字化所有权记录的工具",
  "在 Ternova 上，钱包用于在完成投资后存储代币化的资产所有权。投资者可以选择自托管钱包（如 MetaMask），或使用平台支持的钱包方式":
    "在 Ternova 上，钱包用于在完成投资后存储代币化的资产所有权。投资者可以选择自托管钱包（如 MetaMask），或使用平台支持的钱包方式",
  "钱包并不会改变投资本身的性质，而是以更现代的方式安全地管理所有权，取代传统的纸质或实物凭证":
    "钱包并不会改变投资本身的性质，而是以更现代的方式安全地管理所有权，取代传统的纸质或实物凭证",
  创建帐户: "创建帐户",
  浏览可用项目: "浏览可用项目",
  "在投资之前，所有投资者都必须完成身份验证。此过程有助于确保法规遵从性并保护平台的完整性。":
    "在投资之前，所有投资者都必须完成身份验证。此过程有助于确保法规遵从性并保护平台的完整性。",
  您不需要连接钱包或完成身份验证来创建帐户:
    "您不需要连接钱包或完成身份验证来创建帐户",
  浏览项目: "浏览项目",
  浏览可用项目: "浏览可用项目",
  "一旦你有了账户，你就可以在平台上浏览代币化的房地产项目。每个项目预览都包括高级信息，如资产类型、位置和目标回报概况":
    "一旦你有了账户，你就可以在平台上浏览代币化的房地产项目，每个项目预览都包括高级信息，如资产类型、位置和目标回报概况",
  "随着您进一步完成入职流程，详细的项目信息将变得可用":
    "随着您进一步完成入职流程，详细的项目信息将变得可用",
  "完整身份验证(KYC)": "完整身份验证(KYC)",
  验证您的身份: "验证您的身份",
  "在投资之前，所有投资者都必须完成身份验证。此过程有助于确保法规遵从性并保护平台的完整性":
    "在投资之前，所有投资者都必须完成身份验证，此过程有助于确保法规遵从性并保护平台的完整性",
  身份验证是受监管投资平台的标准要求: "身份验证是受监管投资平台的标准要求",
  "投资前需要验证，但不仅仅是创建账户": "投资前需要验证，但不仅仅是创建账户",
  连接您的钱包: "连接您的钱包",
  连接数字钱包: "连接数字钱包",
  "要投资一个项目，您需要将数字钱包连接到您的Ternova账户。这使您能够以数字和安全的方式持有代币化的所有权权益。":
    "要投资一个项目，您需要将数字钱包连接到您的Ternova账户，这使您能够以数字和安全的方式持有代币化的所有权权益",
  "支持的选项包括：MetaMask（自我保管）、Ternova的平台钱包":
    "支持的选项包括：MetaMask（自我保管）、Ternova的平台钱包",
  "未来可能会支持其他钱包选项。": "未来可能会支持其他钱包选项",
  "只有当您准备投资时，才需要钱包连接。":
    "只有当您准备投资时，才需要钱包连接",
  投资一个项目: "投资一个项目",
  投资现实世界资产: "投资现实世界资产",
  "当你通过Ternova投资时，你购买的是一个代表现实世界资产股权的代币。":
    "当你通过Ternova投资时，你购买的是一个代表现实世界资产股权的代币",
  "这些代币的功能类似于数字股票证书，反映了特定财产或投资结构的所有权。":
    "这些代币的功能类似于数字股票证书，反映了特定财产或投资结构的所有权。",
  "投资代币通常通过特殊目的载体（SPV）或基金进行结构化。":
    "投资代币通常通过特殊目的载体（SPV）或基金进行结构化。",
  "有关这些结构的更多信息，请参阅参考资料部分":
    "有关这些结构的更多信息，请参阅参考资料部分",
  退货与参与: "退货与参与",
  退货和参与: "退货和参与",
  "根据项目的不同，投资者可能会参与：持续的现金流分配长期价值增值":
    "根据项目的不同，投资者可能会参与：持续的现金流分配长期价值增值",
  "分销时间和结构是特定于项目的，并在每个产品中进行了概述。":
    "分销时间和结构是特定于项目的，并在每个产品中进行了概述",
  "未来可能会支持其他钱包选项。": "未来可能会支持其他钱包选项",
  "根据项目的不同，退货可能会分配到您连接的钱包或附属银行账户。":
    "根据项目的不同，退货可能会分配到您连接的钱包或附属银行账户",
  重要注意事项: "重要注意事项",
  "所有投资都有风险。房地产投资可能会受到市场状况、运营因素和更广泛的经济趋势的影响。":
    "所有投资都有风险。房地产投资可能会受到市场状况、运营因素和更广泛的经济趋势的影响。",
  "代币化资产并非没有风险，其流动性可能不如公开交易的证券":
    "代币化资产并非没有风险，其流动性可能不如公开交易的证券",
  "投资前请仔细审查所有项目材料和披露。每次发行都有完整的法律披露。":
    "投资前请仔细审查所有项目材料和披露。每次发行都有完整的法律披露。",
  创建账户: "创建账户",
  探索项目: "探索项目",
  "本页面内容旨在帮助您做出更充分的信息判断，并不替代您自身的评估或专业建议":
    "本页面内容旨在帮助您做出更充分的信息判断，并不替代您自身的评估或专业建议",
  "如需继续了解，您可以返回平台浏览可用项目，或查看投资流程说明":
    "如需继续了解，您可以返回平台浏览可用项目，或查看投资流程说明",
  在Ternova上探索真实世界资产: "在Ternova上探索真实世界资产",
  "浏览下面的当前和即将到来的机会。账户创建和身份验证后，可获得完整的详细信息。":
    "浏览下面的当前和即将到来的机会。账户创建和身份验证后，可获得完整的详细信息。",
  Ternova提供能产生收入的房地产的象征性股权权益:
    "Ternova提供能产生收入的房地产的象征性股权权益",
  " 每个项目都代表着对实际资产的所有权，其结构是为了透明度和长期参与。":
    "每个项目都代表着对实际资产的所有权，其结构是为了透明度和长期参与。",
  "浏览下面的当前和即将到来的机会。账户创建和身份验证后，可获得完整的详细信息。":
    "浏览下面的当前和即将到来的机会。账户创建和身份验证后，可获得完整的详细信息。",
  查看详情: "查看详情",
  项目名称: "项目名称",
  资产类型: "资产类型",
  所在地: "所在地",
  规模: "规模",
  资产概览: "资产概览",
  投资概览: "投资概览",
  所有权与结构: "所有权与结构",
  回报与参与方式: "回报与参与方式",
  文件与链接: "文件与链接",
  立即投资: "立即投资",
  Ternova提供能产生收入的房地产的象征性股权权益:
    "Ternova提供能产生收入的房地产的象征性股权权益",
  "每个项目都代表着对实际资产的所有权，其结构是为了透明度和长期参与。":
    "每个项目都代表着对实际资产的所有权，其结构是为了透明度和长期参与。",
  话题: "话题",
  首页: "首页",
  项目: "项目",
  启动应用: "启动应用",
  合伙人社区: "合伙人社区",

  "Ternova提供能产生收入的房地产的象征性股权权益。每个项目都代表着对实际资产的所有权，其结构是为了透明度和长期参与":
    "Ternova提供能产生收入的房地产的象征性股权权益。每个项目都代表着对实际资产的所有权，其结构是为了透明度和长期参与。",
  创建您的Ternova帐户: "创建您的Ternova帐户",
  "开始使用Ternova首先要创建一个帐户。创建帐户很简单，您可以探索项目、查看机会，并了解更多关于平台工作原理的信息。":
    "开始使用Ternova首先要创建一个帐户，创建帐户很简单，您可以探索项目、查看机会，并了解更多关于平台工作原理的信息",
  "这些代币的功能类似于数字股票证书，反映了特定财产或投资结构的所有权":
    "这些代币的功能类似于数字股票证书，反映了特定财产或投资结构的所有权",
  "投资通常通过特殊目的载体（SPV）或基金进行结构化":
    "投资通常通过特殊目的载体（SPV）或基金进行结构化",
  "在 Ternova 上，钱包用于在完成投资后存储代币化的资产所有权。投资者可以选择自托管钱包（如 MetaMask），或使用平台支持的钱包方式":
    "在 Ternova 上，钱包用于在完成投资后存储代币化的资产所有权。投资者可以选择自托管钱包（如 MetaMask），或使用平台支持的钱包方式",
  浏览项目是否需要连接钱包: "浏览项目是否需要连接钱包",
  这些投资是否具有流动性: "这些投资是否具有流动性",
  在哪里可以查看法律披露文件: "在哪里可以查看法律披露文件",
  "投资资格取决于具体项目及适用法规。有些项目仅面向合格投资者，而另一些项目可能允许更广泛的参与":
    "投资资格取决于具体项目及适用法规。有些项目仅面向合格投资者，而另一些项目可能允许更广泛的参与",
  "身份认证在投资前必须完成。创建账户和浏览项目不需要进行身份认证":
    "身份认证在投资前必须完成。创建账户和浏览项目不需要进行身份认证",
  "不需要,只有在准备投资时才需要连接钱包。":
    "不需要,只有在准备投资时才需要连接钱包。",
  "不需要,只有在准备投资时才需要连接钱包":
    "不需要，只有在准备投资时才需要连接钱包",
  "回报方式取决于具体项目，可能发放至连接的钱包或关联的银行账户":
    "回报方式取决于具体项目，可能发放至连接的钱包或关联的银行账户",
  "房地产投资通常以长期持有为主。代币化旨在提供比传统结构更高的灵活性，但流动性仍可能有限，并取决于具体项目":
    "房地产投资通常以长期持有为主。代币化旨在提供比传统结构更高的灵活性，但流动性仍可能有限，并取决于具体项目",
  在哪里可以查看法律披露文件: "在哪里可以查看法律披露文件",
  "每个项目均包含详细的披露文件和发行资料，投资前应仔细阅读":
    "每个项目均包含详细的披露文件和发行资料，投资前应仔细阅读。",
  创建账户: "创建账户",
  关注我们: "关注我们",
};
